"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteUserForm = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
var react_1 = __importStar(require("react"));
var formik_1 = require("formik");
var Yup = __importStar(require("yup"));
var YellowButton_1 = require("@app/components/controls/YellowButton");
var UsersApi = __importStar(require("@app/services/api/users"));
var matomo_1 = require("@app/shared/matomo");
var utils_1 = require("@app/shared/utils");
var utils_2 = require("@server/shared/utils");
var validationSchema = Yup.object().shape({
    email: Yup.string()
        .email('Please enter a valid email address')
        .test('not-internal', 'Please enter a non-Hasbro email address', function (value) { return !utils_1.isInternalEmail(value); })
        .required('Please enter an email address'),
    firstName: Yup.string().required('Please enter a first name'),
    lastName: Yup.string().required('Please enter a last name'),
    company: Yup.string().required('Please enter a company name')
});
var InviteUserForm = /** @class */ (function (_super) {
    __extends(InviteUserForm, _super);
    function InviteUserForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { userEmail: '' };
        return _this;
    }
    InviteUserForm.prototype.render = function () {
        var _this = this;
        var _a = this.props, errors = _a.errors, touched = _a.touched, loading = _a.loading;
        var validateEmail = function (value) { return __awaiter(_this, void 0, void 0, function () {
            var error, response, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        error = errors.email;
                        if (!(this.state.userEmail !== value)) return [3 /*break*/, 4];
                        this.setState({ userEmail: value }); // Update state with changed email
                        if (!(value && utils_2.isEmail(value))) return [3 /*break*/, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, UsersApi.getUserMinimal(value)];
                    case 2:
                        response = _b.sent();
                        if (value === response.primaryEmail) {
                            error = 'This email address already has an account';
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        error = undefined;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, error];
                }
            });
        }); };
        return (react_1.default.createElement(formik_1.Form, null,
            react_1.default.createElement("div", { className: "field" },
                react_1.default.createElement("label", { className: "label" }, "Email"),
                react_1.default.createElement("div", { className: "control" },
                    react_1.default.createElement(formik_1.Field, { name: "email", type: "email", className: "input", autoFocus: true, validate: validateEmail }),
                    touched.email && errors.email &&
                        react_1.default.createElement("p", { className: "help is-danger", "data-test": "email-error" }, errors.email))),
            react_1.default.createElement("div", { className: "columns" },
                react_1.default.createElement("div", { className: "column" },
                    react_1.default.createElement("div", { className: "field" },
                        react_1.default.createElement("label", { className: "label" }, "First Name"),
                        react_1.default.createElement("div", { className: "control" },
                            react_1.default.createElement(formik_1.Field, { name: "firstName", className: "input" }),
                            touched.firstName && errors.firstName &&
                                react_1.default.createElement("p", { className: "help is-danger", "data-test": "firstname-error" }, errors.firstName)))),
                react_1.default.createElement("div", { className: "column" },
                    react_1.default.createElement("div", { className: "field" },
                        react_1.default.createElement("label", { className: "label" }, "Last Name"),
                        react_1.default.createElement("div", { className: "control" },
                            react_1.default.createElement(formik_1.Field, { name: "lastName", className: "input" }),
                            touched.lastName && errors.lastName &&
                                react_1.default.createElement("p", { className: "help is-danger", "data-test": "lastname-error" }, errors.lastName))))),
            react_1.default.createElement("div", { className: "field" },
                react_1.default.createElement("label", { className: "label" }, "Company"),
                react_1.default.createElement("div", { className: "control" },
                    react_1.default.createElement(formik_1.Field, { name: "company", className: "input" }),
                    touched.company && errors.company &&
                        react_1.default.createElement("p", { className: "help is-danger", "data-test": "company-error" }, errors.company))),
            react_1.default.createElement("div", { className: "field" },
                react_1.default.createElement("label", { className: "label" },
                    "Title ",
                    react_1.default.createElement("span", { className: "help is-inline" }, "(optional)")),
                react_1.default.createElement("div", { className: "control" },
                    react_1.default.createElement(formik_1.Field, { name: "title", className: "input" }),
                    touched.title && errors.title &&
                        react_1.default.createElement("p", { className: "help is-danger" }, errors.title))),
            react_1.default.createElement("div", { className: "field" },
                react_1.default.createElement("label", { className: "label" },
                    "Location ",
                    react_1.default.createElement("span", { className: "help is-inline" }, "(optional)")),
                react_1.default.createElement("div", { className: "control" },
                    react_1.default.createElement(formik_1.Field, { name: "location", className: "input" }),
                    touched.location && errors.location &&
                        react_1.default.createElement("p", { className: "help is-danger" }, errors.location))),
            react_1.default.createElement("div", { className: "control" },
                react_1.default.createElement(YellowButton_1.YellowButton, { disabled: loading, onClick: function () { new matomo_1.MatomoTracker().trackEvent('User', 'Invited New User'); }, type: "submit", "data-test": "submit-button", className: "button-large" }, "Invite User"))));
    };
    return InviteUserForm;
}(react_1.Component));
exports.InviteUserForm = InviteUserForm;
exports.default = formik_1.withFormik({
    validationSchema: validationSchema,
    mapPropsToValues: function (props) {
        return {
            email: '',
            firstName: '',
            lastName: '',
            company: '',
            title: '',
            location: ''
        };
    },
    handleSubmit: function (values, bag) {
        bag.props.onSubmit(values);
    }
})(InviteUserForm);
